import * as images from './avatars'
const pictureData = require('schema').picturePasswords

const avatars = pictureData.map(image => ({
  ...image,
  src: images[image.value]
}))
export default avatars
